import {isUndefined} from "lodash";
import * as React from "react";
import {IPaginatorMeta, ListTableStore} from "../../stores/ListTableStore";
import {observer} from "mobx-react";
import {Pagination, PaginationItem, PaginationLink, Table} from "reactstrap";
import {SyntheticEvent} from "react";

class Paginator extends React.Component<{pagination: IPaginatorMeta, onPaginate: (page: number) => void}> {
    toPage = (e: SyntheticEvent, page: number) => {
        e.preventDefault();
        this.props.onPaginate(page);
    };

    render() {
        const {pagination} = this.props;
        const paginationItems = [];

        for (let i = 1; i <= pagination.last_page; i += 1) {
            if (pagination.last_page > 10 && i > 3 && i < pagination.last_page - 2) {
                if (i == pagination.current_page - 3 || i == pagination.current_page + 3) {
                    paginationItems.push(
                        <PaginationItem key={i} disabled>
                            <PaginationLink href="#">
                                ...
                            </PaginationLink>
                        </PaginationItem>
                    );
                    continue;
                }
                if (i < pagination.current_page - 2 || i > pagination.current_page + 2) {
                    continue;
                }
            }

            paginationItems.push(
                <PaginationItem key={i} active={i === pagination.current_page}>
                    <PaginationLink href="#" onClick={(e) => this.toPage(e, i)}>
                        {i}
                    </PaginationLink>
                </PaginationItem>
            )
        }

        return (
            <Pagination aria-label="Page navigation example">
				<PaginationItem disabled><PaginationLink href="#">Total Record: {pagination.total}</PaginationLink></PaginationItem>
				
				
                <PaginationItem disabled={pagination.current_page === 1}>
                    <PaginationLink previous href="#" onClick={(e) => this.toPage(e, pagination.current_page - 1)} />
                </PaginationItem>
                {paginationItems}
                <PaginationItem disabled={pagination.current_page === pagination.last_page}>
                    <PaginationLink next href="#" onClick={(e) => this.toPage(e, pagination.current_page + 1)} />
                </PaginationItem>
            </Pagination>
        );
    }
}

type IColumn = {
    name?: string;
    label: string;
    formatter?: (value: any, item: any, column: IColumn) => any;
    style?: any;
    sort?: boolean;
    sortColumn?: string;
    defaultSort?: boolean;
}

@observer
class Thead extends React.Component<{columns: IColumn[], onSort: any, store: ListTableStore}> {
    onSort = (column?: string, direction: string = 'asc') => {
        this.props.onSort(column, direction);
    };

    sortLink = (column: any) => {
        const {store} = this.props;
        if (!column) {
            return '';
        }
        const columnName = (column.sortColumn) ? column.sortColumn : column.name;
        if (columnName === store.orderColumn && store.orderDirection === 'asc') {
            return <a href="#" onClick={(e) => {this.onSort(columnName, 'desc');e.preventDefault();}}><span className="icon-sort-down"/></a>
        } else if (columnName === store.orderColumn && store.orderDirection === 'desc') {
            return <a href="#" onClick={(e) => {this.onSort(columnName, 'asc');e.preventDefault();}}><span className="icon-sort-up"/></a>
        } else if (column.sort) {
            return  <span className="sort-wrap">
                <a href="#" onClick={(e) => {this.onSort(columnName, 'asc');e.preventDefault();}}><span className="icon-sort-up"/></a>
                <a href="#" onClick={(e) => {this.onSort(columnName, 'desc');e.preventDefault();}}><span className="icon-sort-down"/></a>
            </span>
        } else {
            return '';
        }
    };

    render() {
        const {columns} = this.props;

        return (
            <thead>
            <tr>
                {columns.map((column: IColumn, index) => {
                    return (
                        <th key={index} style={column.style}>
                            <div className="d-flex justify-content-between">
                                <span className="column-name">{column.label}</span>
                                {this.sortLink(column)}
                            </div>
                        </th>
                    );
                }
                )}
            </tr>
            </thead>
        );
    }
}

class Column extends React.Component<{column: IColumn, item: any}> {
    _getValue(path: string[], data: any): any {
        if (path.length === 0) {
            return data;
        }

        const [name, ...rest] = path;

        if (data === null || isUndefined(data[name])) {
            return null;
        }

        return this._getValue(rest, data[name]);
    }

    getValue(item: any, name: string) {
        return this._getValue(name.split("."), item);
    }

    render() {
        const {column, item} = this.props;
        const value = column.name ? this.getValue(item, column.name) : null;
        let component = value;

        if (column.formatter) {
            component = column.formatter(value, item, column);
        }

        return (
            <td style={column.style}>{component}</td>
        );
    }
}

class Row extends React.Component<{columns: IColumn[], item: any}> {
    render() {
        const {columns, item} = this.props;

        return (
            <tr>
                {columns.map((column: IColumn, index) => <Column key={index} column={column} item={item}/>)}
            </tr>
        );
    }
}

class Tbody extends React.Component<{columns: IColumn[], items: any[]}> {
    render() {
        const {columns, items} = this.props;

        return (
            <tbody>
                {items.map((item: any) => <Row key={item.id} columns={columns} item={item}/>)}
            </tbody>
        );
    }
}

interface IListTableProps {
    store: ListTableStore;
    columns: IColumn[];
    readOnly?: boolean;
}

@observer
export class ListTable extends React.Component<IListTableProps> {
    private onPaginate = (page: number) => {
        this.props.store.fetchItems(page);
    };

    private onSort = (column: string, direction: string) => {
        this.props.store.setOrder(column, direction);
        this.props.store.fetchItems(1);
    };

    public render() {
        const {store: {isLoading, items, pagination}, columns, store} = this.props;

        return (
            <>
			
                <Table hover responsive className="grid">
                    <Thead columns={columns} onSort={this.onSort} store={store}/>
                    <Tbody columns={columns} items={items} />
                </Table>
                <div className="d-flex">
                    <div className="flex-grow-1">
                        {isLoading && 'Loading ...'}
                    </div>
                     {!!pagination && <Paginator pagination={pagination} onPaginate={this.onPaginate}/>}
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/list/ListTable.tsx